import { render, staticRenderFns } from "./CardProductInformation.vue?vue&type=template&id=3994ddea&scoped=true&"
import script from "./CardProductInformation.vue?vue&type=script&lang=js&"
export * from "./CardProductInformation.vue?vue&type=script&lang=js&"
import style0 from "./CardProductInformation.vue?vue&type=style&index=0&id=3994ddea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994ddea",
  null
  
)

export default component.exports